import mixpanel from "mixpanel-browser";
// require("dotenv").config();
let mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN || "";
if (process.env.REACT_APP_PRODUCTION === "production") {
  mixpanel.init(mixpanelToken); // prod
} else if (process.env.REACT_APP_PRODUCTION === "development") {
  mixpanel.init(mixpanelToken); // dev or local
} else {
  mixpanel.init(mixpanelToken);
}

let actions = {
  identify: (id?: string) => {
    const userId = JSON.parse(
      localStorage.getItem("currentUser") as any
    ) as any;
    if (userId?.user?.id) {
      mixpanel.identify(userId.user.id);
    } else {
      mixpanel.identify(id);
    }
  },
  alias: (id: any) => {
    mixpanel.alias(id);
  },
  track: (name: any, props: any) => {
    mixpanel.track(name, props);
  },
  people: {
    set: (props: any) => {
      mixpanel.people.set(props);
    }
  }
};

export let Mixpanel = actions;
